import { useState } from 'react';

interface SwipeInput {
  onSwipeLeft?: () => void;
  onSwipeRight?: () => void;
  onSwipeUp?: () => void;
  onSwipeDown?: () => void;
}

export const useSwipeGesture = ({ onSwipeLeft, onSwipeRight, onSwipeUp, onSwipeDown }: SwipeInput) => {
  const [touchStart, setTouchStart] = useState<{ x: number; y: number } | null>(null);
  const [touchEnd, setTouchEnd] = useState<{ x: number; y: number } | null>(null);
  const [isValidSwipe, setIsValidSwipe] = useState(false);

  const minSwipeDistance = 80;
  const maxVerticalDeviation = 100;

  const onTouchStart = (e: TouchEvent) => {
    setTouchEnd(null);
    const startX = e.targetTouches[0].clientX;
    const startY = e.targetTouches[0].clientY;
    
    setTouchStart({ x: startX, y: startY });
    
    // For right swipe (drawer open), only allow from left edge
    if (startX < 50) {
      setIsValidSwipe(true);
    } else {
      setIsValidSwipe(false);
    }
  };

  const onTouchMove = (e: TouchEvent) => {
    setTouchEnd({
      x: e.targetTouches[0].clientX,
      y: e.targetTouches[0].clientY,
    });
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;

    const distanceX = touchStart.x - touchEnd.x;
    const distanceY = touchStart.y - touchEnd.y;
    const isLeftSwipe = distanceX > minSwipeDistance;
    const isRightSwipe = distanceX < -minSwipeDistance;
    const isUpSwipe = distanceY > minSwipeDistance;
    const isDownSwipe = distanceY < -minSwipeDistance;

    // Check if horizontal swipe with minimal vertical movement
    const isHorizontalSwipe = Math.abs(distanceX) > Math.abs(distanceY) && Math.abs(distanceY) < maxVerticalDeviation;
    
    if (isHorizontalSwipe) {
      if (isLeftSwipe && onSwipeLeft) onSwipeLeft();
      if (isRightSwipe && onSwipeRight && isValidSwipe) onSwipeRight();
    } else if (Math.abs(distanceY) > Math.abs(distanceX)) {
      if (isUpSwipe && onSwipeUp) onSwipeUp();
      if (isDownSwipe && onSwipeDown) onSwipeDown();
    }
    
    setIsValidSwipe(false);
  };

  return {
    onTouchStart,
    onTouchMove,
    onTouchEnd,
  };
};